// extracted by mini-css-extract-plugin
module.exports = {"stickyButtonContainer":"az_cab","applyBtn":"az_dab"};